"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.register = register;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _quickRegister = require("../repositories/monolith-csharp/users/v1/quick-register");
const _excluded = ["subdomain"];
function register(httpApi, parameters) {
  const {
      subdomain
    } = parameters,
    restParameters = (0, _objectWithoutProperties2.default)(parameters, _excluded);
  return (0, _quickRegister.fetchQuickRegister)({
    httpApi,
    parameters: restParameters,
    config: {
      subdomain,
      bodyAsEncodeString: true,
      requestConfig: {
        headers: [['Content-Type', 'application/x-www-form-urlencoded']],
        withCredentials: true
      }
    }
  });
}